import React from "react";
import { useQuery, gql } from "@apollo/client";
import { PageNumber } from "../PageNumber/PageNumber";
import { Link } from "gatsby";
import { formatDate, estimateReadTime } from "../../utils";

export const NewsIndexNonSticky = () => {
  const pageSize = 10;
  let page = 1;

  if (typeof window !== "undefined") {
    const params = new URLSearchParams(window.location.search);
    page = parseInt(params.get("page") || "1");
  }

  const { data, loading } = useQuery(
    gql`
      query NewsQuery($size: Int!, $offset: Int!) {
        posts(where: { offsetPagination: { size: $size, offset: $offset } }) {
          nodes {
            databaseId
            title
            excerpt
            uri
            date
            content
            tags {
              nodes {
                link
                name
                slug
              }
            }
            featuredImage {
              node {
                sourceUrl(size: LARGE)
              }
            }
          }
          pageInfo {
            offsetPagination {
              total
            }
          }
        }
      }
    `,
    {
      variables: {
        size: pageSize,
        offset: pageSize * (page - 1),
      },
    }
  );

  const totalResults = data?.posts?.pageInfo?.offsetPagination?.total || 0;
  const totalPages = Math.ceil(totalResults / pageSize);

  return (
    <div className="newsindex min-w-fit">
      {!loading && !!data?.posts?.nodes?.length && (
        <div>
          {data.posts.nodes.map((post, i) => {

              return (
                <article
                  key={post.databaseId}
                  className={`mb-[36px] xl:mb-[75px] flex mx-0 w-[calc(100% + 48px)] sm:w-full lg:w-[900px] xl:w-[1000px] md:items-center md:justify-between md:p-4 flex-col ${(i % 2 === 0) ? "md:flex-row-reverse" : "md:flex-row"}`}
                > 
                  {!!post.featuredImage?.node?.sourceUrl && (
                    <div className="md:relative w-full md:h-[300px] md:w-[300px] lg:h-[350px] lg:w-[350px] xl:h-[400px] xl:w-[400px]">
                      <div className={`hidden md:block md:absolute bg-color-gray-light h-[300px] w-[300px] lg:h-[350px] lg:w-[350px] xl:h-[400px] xl:w-[400px] ${(i % 2 === 0) ? "md:right-[-10px] lg:right-[-18px] xl:right-[-25px]" : "md:left-[-10px] lg:left-[-18px] xl:left-[-25px]"} md:top-[-10px] lg:top-[-18px] xl:top-[-25px]`}></div>
                      <Link to={post.uri}>
                        <img
                          className={`md:absolute aspect-[4/3] sm:aspect-video md:aspect-square md:h-[300px] lg:h-[350px] xl:h-[400px] object-cover ${(i % 2 === 0) ? "md:right-[10px] lg:right-[18px] xl:right-[25px]" : "md:left-[10px] lg:left-[18px] xl:left-[25px]"} md:top-[10px] lg:top-[18px] xl:top-[25px] md:hover:translate-y-4  ${(i % 2 === 0) ? "md:hover:translate-x-[-1rem]" : "md:hover:translate-x-4"} ease-in-out duration-500`}
                          src={post.featuredImage.node.sourceUrl}
                          alt=""
                        />
                      </Link>
                    </div>
                  )}
                  <div className="flex w-full md:w-1/2 xl:w-[40%] flex-col content-between pl-6 pr-8 pt-8 md:p-0">
                    <h2 className="text-left text-3xl font-bold leading-tight text-color-black">
                      <Link
                        className="cursor-pointer text-left text-3xl font-bold leading-tight !text-color-black no-underline"
                        to={post.uri}
                      >
                        {post.title}
                      </Link>
                    </h2>
                    <div
                      className="text-base text-color-gray-dark mb-3"
                      dangerouslySetInnerHTML={{ __html: post.excerpt }}
                    ></div>
                    <div className="reading text-sm text-color-gray-dark mb-3">
                      <span>{formatDate(post.date)}</span>
                      <span>&nbsp;&bull;&nbsp;</span>
                      <span>{estimateReadTime(post.content)} minute read</span>
                    </div>
                    <div className="tags text-color-gray-dark">
                      {post.tags.nodes.map((tag) => (
                        <h4 className="text-xs uppercase pb-1 border-color-gray-dark-2 text-color-black w-auto inline-block ease-in-out duration-300 hover:border-b-0 border-b-4">{tag.name}</h4>
                      ))}
                    </div>
                  </div>
                </article>
              )
          })}
        </div>
      )}
      {!!totalResults && (
        <div className="my-4 flex items-center justify-center gap-2">
          {Array.from({ length: totalPages }).map((_, i) => {
            return <PageNumber key={i} pageNumber={i + 1} />;
          })}
        </div>
      )}
    </div>
  );
};
